import { FunctionComponent } from 'react';

import { IPosition } from '../../../model';

type Props = {
  coordinates: IPosition | null | undefined;
};

export const CoordinatesTextShort: FunctionComponent<Props> = ({ coordinates }) => {
  if (!coordinates) return null;

  return (
    <span>
      {coordinates.latitude}, {coordinates.longitude}
    </span>
  );
};
